<div [ngClass]="{ 'chat-sidebar': true, 'min-width': isPinned() }">
  <!-- Sidebar Toggle Button (when not pinned) -->
  @if (!isPinned() && !sidebarVisible) {
    <div
      [ngClass]="{ 'is-native': isNative, 'sidebar-toggle': true }"
      (click)="changeSidebarVisible(true, true)"
      [pTooltip]="'Open chat sidebar'"
      tooltipPosition="bottom"
      tooltipStyleClass="u-tooltip"
    >
      <ng-container *ngTemplateOutlet="currentAssistantContent"></ng-container>
      <u-icon
        [model]="{ type: 'font', value: 'icon-chevron-down1' }"
        [styles]="{ fontSize: '16px', color: 'var(--color-text-secondary)', display: 'flex', width: 'intial', height: 'intial' }"
      ></u-icon>
    </div>
  }
  <u-sidebar
    [visible]="sidebarVisible"
    [transitionOptions]="transitionOptions"
    [content]="content"
    [header]="header"
    [showCloseIcon]="false"
    [showMask]="false"
  >
  </u-sidebar>
  <!-- Pinned Sidebar Container -->
  @if (isPinned()) {
    <div class="chat-sidebar-container pinned" @slideInOut>
      <div class="assistant-header">
        <ng-container *ngTemplateOutlet="currentAssistantContent"></ng-container>
      </div>
      <ng-container *ngTemplateOutlet="content"></ng-container>
      <div class="footer"><ng-container *ngTemplateOutlet="footer"></ng-container></div>
    </div>
  }
</div>

<ng-template #currentAssistantContent>
  <chat-sidebar-assistant-item
    class="header"
    [assistantItem]="currentAssistant()"
    [isPinned]="isPinned()"
    [isSmallScreen]="isSmallScreen"
    [isHeader]="true"
    (sidebarPinnedState)="setSidebarPinnedState($event)"
  ></chat-sidebar-assistant-item>
</ng-template>
<ng-template #header>
  <div class="assistant-header">
    <ng-container *ngTemplateOutlet="currentAssistantContent"></ng-container>
  </div>
</ng-template>
<ng-template #content>
  <div class="side-bar-search-wrapper">
    <u-input
      class="search-input"
      (onChange)="updateFilter($event)"
      [inlineExtraIcon]="{ type: 'font', value: 'icon-search-icon-fixed' }"
      [placeholder]="searchPlaceholder()"
      [inputSize]="'small'"
      [isSearchInput]="true"
    ></u-input>
  </div>
  <div class="sidebar-content">
    <ng-scrollbar #mainScroll [class.hide-scroll]="!showScrollBar()">
      @if (assistantsList()?.length) {
        @if (groupedSessions()?.length) {
          <div class="assistant-scroll-wrapper" [class.filter-state]="filterValue()">
            <ng-scrollbar
              #assistantsScroll
              [style.height]="assistantsContainerHeight()"
              [class.hide-scroll]="!showAssistantsScrollBar()"
              (mouseleave)="hideAssistantScrollbar()"
            >
              <ng-container *ngTemplateOutlet="assistantsListTemplate"></ng-container>
            </ng-scrollbar>
          </div>
        } @else {
          <div class="assistants-without-scroll">
            <ng-container *ngTemplateOutlet="assistantsListTemplate"></ng-container>
          </div>
        }
      }
      @if (groupedSessions()?.length) {
        <div class="sessions-content" (mouseleave)="hideScrollbar()">
          <u-list-box
            (selectedChange)="selectedSession($event)"
            [selectedItem]="currentSession()"
            [items]="groupedSessions()"
            [filter]="false"
            [group]="true"
            [groupTemplate]="groupItem"
            [itemTemplate]="sessionItem"
            [selectOnFocus]="false"
          >
          </u-list-box>
        </div>
      }
      @if (noResults()) {
        <div class="sidebar-empty-state">No results</div>
      }
    </ng-scrollbar>
  </div>
</ng-template>

<ng-template #assistantsListTemplate>
  <div class="assistant-wrapper">
    <chat-sidebar-assistant-item
      *ngFor="let assistant of assistantsList(); let index = index; trackBy: trackByAssistant"
      [assistantItem]="assistant"
      (closeSidebar)="closeSidebarIfUnpinned()"
    ></chat-sidebar-assistant-item>
  </div>
</ng-template>

<ng-template #sessionItem let-item let-index="index">
  <chat-sidebar-session-item
    [sessionItem]="item"
    [selectedSessionId]="currentSessionId()"
    [(currentTypingSessionId)]="currentTypingSessionId"
  >
  </chat-sidebar-session-item>
</ng-template>

<ng-template #groupItem let-group let-index="index">
  <div class="session-group">
    <div class="session-title">{{ group['label'] }}</div>
    <div class="session-list"></div>
  </div>
</ng-template>
